import landing from "./landing.json";
import customRouter from "./customRouter.json";
import error from "./error.json";
import login from "./login.json";

export const i18n = {
  error,
  customRouter,
  login,
  landing
};
